console.log('new subscription widget custom is loading')
// Subscription widget not appearing on firefox
// Subscription widget - Border color change
var subscription_widget_main_style = `
    .compact .rc-purchase-option__label{
        justify-content: flex-start!important;
    }
    
    .rc-purchase-option__sub-container{
        flex-direction: column-reverse!important;
    }
    
    .compact .rc-purchase-option__prices{
        flex-direction: row-reverse!important;
        gap: 5px!important;
    }
    
    .rc-purchase-option__badge{
        top: 12px!important;
        right: 20px!important;
    }
    
    .rc-selection__onetime{
        border: 1px solid #DADAD9!important;
    }
    
    .rc-purchase-option__subscription{
        border: 1px solid #DADAD9!important;
    }

    .rc-purchase-option[rc-selected]{
        border-color: #575453 !important;
        border-width: 2.5px !important;
    }
    
    .rc-purchase-option__sub-container{
        gap: 15px!important;
    }
    
    .rc-purchase-option__selector{
        font-size: 16px!important;
        font-weight: 400!important;
        font-family: Inter Regular, sans-serif !important;
    }
    
    .rc-price{
        font-family: Inter Regular,sans-serif !important;
        font-size: 16px!important;
    }
    
    .rc-purchase-option__badge{
        font-family: Sofia Pro,sans-serif!important;
        font-size: 13px!important;
        font-weight: 700!important;
    }
    
    .rc-purchase-option__subscription .rc-purchase-option__selector:after{
      content: url(/cdn/shop/files/Group_761.svg?v=1704290290);
    }
    
    .rc-selection__onetime .rc-purchase-option__selector{
        padding-right: 7px!important;
    }
    
    .rc-purchase-option__checked-indicator{
      position: relative!important;
    }
    
    .rc-selection__onetime .rc-purchase-option__sub-container{
      display: none!important;
    }
    
    .show-element{
      display: block!important;
    }
    
    .new-subscribe-content {
      padding: 0px 20px 20px 40px;
      display: none;
    }
    
    .new-subscribe-content p{
      color: #21653b!important;
      margin: 1px !important;
      font-family: Inter Regular,sans-serif!important;
      padding-left: 15px;
      position: relative;
    }
    
    .new-subscribe-content p:before{
      content: url(/cdn/shop/files/Vector_13.svg?v=1704397153);
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translate(-100%, -50%);
    }
  
    .new-stike-price{
      text-decoration-line: line-through;
      line-height: 1em;
      color: var(--rc-widget-brand-color-70);
      font-weight: 400;
      font-family: Inter Regular, sans-serif !important;
      font-size: 16px !important;
    }
  
    .rc-price.strike-through{
      display: none!important;
    }
    
    @media (max-width: 1024px){
      .rc-purchase-option__subscription .rc-purchase-option__label{
        padding-top: 30px!important;
      }

      .rc-purchase-option__badge{
        top: 30px!important;
      }
    }
    
    @media (max-width: 900px){
      .rc-purchase-option__subscription .rc-purchase-option__selector:after{
        content: '';
      }
    }
    
    @media (max-width: 890px) and (min-width: 769px){
      .rc-purchase-option__subscription .rc-purchase-option__label{
        padding: 30px 10px 12px 10px!important;
      }
    
      .rc-purchase-option__prices{
        margin-left: 10px!important;
      }
    }
    
    @media (max-width: 768px){
      .rc-purchase-option__subscription .rc-purchase-option__selector{
        padding-right: 5px!important;
      }
    }
    
    @media (max-width: 425px){
      .rc-purchase-option__prices{
        margin-left: 5px!important;
      }
    }
  
    @media (max-width: 365px){
      .rc-purchase-option__label{
        padding-left: 10px!important;
        padding-right: 10px!important;
      }
    }
  `;

var subscription_widget_parchace_option_check_box_style = `
    .new_chech_box{
      position: absolute;
      content: "";
      width: 20px;
      height: 20px;
      display: block;
      position: absolute;
      top: 0;
      border: 0;
      left: 0;
      border-radius: 50%;
      background-color: #21653b;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .new_chech_box div{
      content: "";
      width: 6px;
      height: 6px;
      display: block;
      position: absolute;
      top: 7px;
      left: 7px;
      border-radius: 50%;
      background-color: #fff;
    }
  `;

var subscription_widget_hidden_svg_style = `
    svg{
      display: none!important;
    }
  `;

var subscription_widget_benefits_content_style = `
    p{
      color: #21653b!important;
      margin: 1px !important;
      font-family: Inter Regular,sans-serif!important;
      padding-left: 15px;
      position: relative;
    }
    
    p:before{
      content: url(/cdn/shop/files/Vector_13.svg?v=1704397153);
      position: absolute;
      left: 10px;
      top: 0;
      transform: translate(-100%, 0);
    }
  `;

var subscription_widget_select_option_style = `
    select{
      height: 48px;
      border-radius: 0px!important;
      border: var(--input-border-width) solid rgba(var(--input-text-color) / .2);
      color: #5d5d5d;
      font-family: Inter Regular, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
  `;

  document.addEventListener("DOMContentLoaded", function () {
    var style_state = false;
    var script_state = false;
    var content_state = false;
    var select_state = false;
    var fir_select_state = false;
    var se_select_state = false;
    var click_state = false;
    var show_state = false;
    var compare_at_price_state = false;
    var dynamic_button_state = false;

    function waitForRechargeWidget() {
        const widgetSelector = 'recharge-subscription-widget';
      
        // MutationObserver to detect dynamic loading
        const observer = new MutationObserver(() => {
          const widget = document.querySelector(widgetSelector);
      
          if (widget && widget.shadowRoot) {
            const isLoaded = widget.shadowRoot.querySelector('.rc-selection__root'); // Replace with actual class inside
            if (isLoaded) {
                console.log('///Recharge Subscription Widget is fully rendered!');
                var shadowRoot = widget.shadowRoot;
                
                // Show widget
                widget.classList.add('show-subscription-widget')

                // Apply widget's custom main styles
                var style = document.createElement('style');
                style.textContent = subscription_widget_main_style;
                shadowRoot.appendChild(style);

                // Apply widget's content's styles
                var element = shadowRoot.querySelectorAll('.rc-purchase-option');
                element.forEach((item,index)=>{
                    if(item.hasAttribute('rc-selected')){
                        if(item.classList.contains('rc-purchase-option__subscription')){
                            if(shadowRoot.querySelector('rc-benefits').shadowRoot){
                                var onetime_root = shadowRoot.querySelector('rc-benefits').shadowRoot;
                                if(onetime_root.querySelector('.rc-benefits__list')){
                                    var content = onetime_root.querySelector('.rc-benefits__list');
        
                                    createNewDetails(content, 'subscribe')
                                }
                            }
                        }
                        else if(item.classList.contains('rc-selection__onetime')){
                            if(shadowRoot.querySelector('rc-onetime-drawbacks').shadowRoot){
                                var onetime_root = shadowRoot.querySelector('rc-onetime-drawbacks').shadowRoot;
                                if(onetime_root.querySelector('.rc-drawbacks')){
                                    var content = onetime_root.querySelector('.rc-drawbacks');
        
                                    createNewDetails(content, 'one-time')
                                }
                            }
                        }
                    }
                });

                // Add state's style
                if(shadowRoot.querySelectorAll('.rc-purchase-option')){
                    var click_elements = shadowRoot.querySelectorAll('.rc-purchase-option');

                    var new_strike_price = document.createElement('span');
                    new_strike_price.classList.add('new-stike-price');

                    shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices')?.insertBefore(new_strike_price, shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price.strike-through'));

                    var compare_at_price_value = document.querySelector('.product-info .product-info__block .price__default .price__was').textContent;

                    if (compare_at_price_value) {
                        changeCompareAtPrice(compare_at_price_value);
                    }
                    else {
                        var price = shadowRoot.querySelector('.rc-selection__onetime .rc-price')?.textContent;
                        changeCompareAtPrice(price);
                    }

                    click_elements.forEach((item, index) => {
                        if(item.hasAttribute('rc-selected')){
                            if(item.classList.contains('rc-purchase-option__subscription')){
                                click_check_box(item);
                                updateDynamicBadge(0.8);
                                setTimeout(()=>{
                                    addDetailsStyle(item);
                                }, 100)
                            }
                            else if(item.classList.contains('rc-selection__onetime')){
                                click_check_box(item);
                            }

                            checkPrice(item)
                        }
                    });
                }

                dynamicSubscribeButton();

              observer.disconnect();
            }
          }
        });
      
        observer.observe(document.body, { childList: true, subtree: true });
      }
      
      // Call the function to start monitoring
      waitForRechargeWidget();
  });

// document.addEventListener("DOMContentLoaded", function () {
//     return;

//     var targetNode = document.body;
//     var config = { childList: true, subtree: true, autocomplete: false };


//     var style_state = false;
//     var script_state = false;
//     var content_state = false;
//     var select_state = false;
//     var fir_select_state = false;
//     var se_select_state = false;
//     var click_state = false;
//     var show_state = false;
//     var compare_at_price_state = false;
//     var dynamic_button_state = false;

//     var callback = function (mutationsList, observer) {
//         for (var mutation of mutationsList) {
//             if (mutation.type === 'childList') {
//                 // if (document.querySelector('recharge-subscription-widget')) {
//                 if (document.querySelector('recharge-subscription-widget') instanceof HTMLElement && document.querySelector('recharge-subscription-widget').shadowRoot) {

//                     if (show_state == false) {
                        
//                         show_state = true
//                         const inter = setInterval(() => {
//                             if(document.querySelector('recharge-subscription-widget')){
//                                 var rechargeWidget = document.querySelector('recharge-subscription-widget');
//                                 if(rechargeWidget.shadowRoot){
//                                     var shadowRoot = rechargeWidget.shadowRoot;
                                    
//                                     if (shadowRoot.querySelector('style')) {
//                                         rechargeWidget.classList.add('show-subscription-widget')
//                                         clearInterval(inter);

//                                         console.log('***************************new subscription widget loaded');
//                                     }
//                                 }
//                             }
//                         }, 100)
//                     }


//                     if (style_state == false && show_state) {
                        
//                         style_state = true;

//                         setTimeout(() => {
//                             if(document.querySelector('recharge-subscription-widget')){
//                                 var rechargeWidget = document.querySelector('recharge-subscription-widget');
//                                 if(rechargeWidget.shadowRoot){
//                                     var shadowRoot = rechargeWidget.shadowRoot;
        
//                                     var style = document.createElement('style');
        
//                                     style.textContent = subscription_widget_main_style;
        
//                                     shadowRoot.appendChild(style);

//                                     console.log('the subscription widget main style has been added');
//                                 }
//                             }
//                         }, 1000)

//                     }

//                     if (content_state == false && show_state) {
//                         content_state = true;

//                         if(document.querySelector('recharge-subscription-widget')){
//                             var rechargeWidget = document.querySelector('recharge-subscription-widget');
//                             if(rechargeWidget.shadowRoot){
//                                 setTimeout(() => {
//                                     var shadowRoot = rechargeWidget.shadowRoot;
        
//                                     var element = shadowRoot.querySelectorAll('.rc-purchase-option');

//                                     element.forEach((item,index)=>{
//                                         if(item.hasAttribute('rc-selected')){
//                                             if(item.classList.contains('rc-purchase-option__subscription')){
//                                                 if(shadowRoot.querySelector('rc-benefits').shadowRoot){
//                                                     var onetime_root = shadowRoot.querySelector('rc-benefits').shadowRoot;
//                                                     if(onetime_root.querySelector('.rc-benefits__list')){
//                                                         var content = onetime_root.querySelector('.rc-benefits__list');
                            
//                                                         createNewDetails(content, 'subscribe')
//                                                     }
//                                                 }
//                                             }
//                                             else if(item.classList.contains('rc-selection__onetime')){
//                                                 if(shadowRoot.querySelector('rc-onetime-drawbacks').shadowRoot){
//                                                     var onetime_root = shadowRoot.querySelector('rc-onetime-drawbacks').shadowRoot;
//                                                     if(onetime_root.querySelector('.rc-drawbacks')){
//                                                         var content = onetime_root.querySelector('.rc-drawbacks');
                            
//                                                         createNewDetails(content, 'one-time')
//                                                     }
//                                                 }
//                                             }
//                                         }
//                                     })
//                                 }, 1000)
//                             }
//                         }
//                     }

//                     if (select_state == false && show_state) {

//                         console.log('new subscription custom click function loaded')

//                         select_state = true;

//                         setTimeout(() => {
//                             if(document.querySelector('recharge-subscription-widget')){
//                                 var rechargeWidget = document.querySelector('recharge-subscription-widget');
//                                 if(rechargeWidget.shadowRoot){
//                                     var shadowRoot = rechargeWidget.shadowRoot;
                                    
//                                     if(shadowRoot.querySelectorAll('.rc-purchase-option')){
//                                         var click_elements = shadowRoot.querySelectorAll('.rc-purchase-option');

//                                         var new_strike_price = document.createElement('span');
//                                         new_strike_price.classList.add('new-stike-price');

//                                         shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices')?.insertBefore(new_strike_price, shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price.strike-through'));

//                                         var compare_at_price_value = document.querySelector('.product-info .product-info__block .price__default .price__was').textContent;

//                                         if (compare_at_price_value) {
//                                             changeCompareAtPrice(compare_at_price_value);
//                                         }
//                                         else {
//                                             var price = shadowRoot.querySelector('.rc-selection__onetime .rc-price')?.textContent;
//                                             changeCompareAtPrice(price);
//                                         }
            
//                                         click_elements.forEach((item, index) => {
//                                             if(item.hasAttribute('rc-selected')){
//                                                 if(item.classList.contains('rc-purchase-option__subscription')){
//                                                     click_check_box(item);
//                                                     updateDynamicBadge(0.8);
//                                                     setTimeout(()=>{
//                                                       addDetailsStyle(item);
//                                                     }, 100)
//                                                 }
//                                                 else if(item.classList.contains('rc-selection__onetime')){
//                                                     click_check_box(item);
//                                                 }

//                                                 checkPrice(item)
//                                             }
            
//                                             item.querySelector('.rc-purchase-option__label').addEventListener('click', function () {
//                                                 /*-->Subscription Widget bug  */
//                                                 return;
//                                                 /*<--Subscription Widget bug  */

//                                                 if (item.classList.contains('rc-selection__onetime')) {
//                                                     changeClassname(shadowRoot.querySelector('.new-subscribe-content'), 'show-element', 'add')
//                                                     updateDynamicBadge(1);

//                                                     var remove_element = shadowRoot.querySelector('.rc-purchase-option__subscription rc-radio-icon').shadowRoot;
//                                                     if(remove_element.querySelectorAll('.new_chech_box').length > 0){
//                                                       var remove_element_items = remove_element.querySelectorAll('.new_chech_box');

//                                                       remove_element_items.forEach((item, index)=>{
//                                                         item.remove();
//                                                       })
                                                      
//                                                     }
                                                  
//                                                 }
//                                                 else {
//                                                     changeClassname(shadowRoot.querySelector('.new-subscribe-content'), 'show-element', 'remove');
//                                                     updateDynamicBadge(0.8);

//                                                     var remove_element = shadowRoot.querySelector('.rc-selection__onetime rc-radio-icon').shadowRoot;
//                                                     if(remove_element.querySelectorAll('.new_chech_box').length > 0){
//                                                       var remove_element_items = remove_element.querySelectorAll('.new_chech_box');

//                                                       remove_element_items.forEach((item, index)=>{
//                                                         item.remove();
//                                                       })
                                                      
//                                                     }

//                                                     setTimeout(()=>{
//                                                       addDetailsStyle(item)
//                                                     }, 100)
//                                                 }
//                                                 click_check_box(item)
//                                             })
//                                         })

//                                         /*-->Subscription Widget bug*/
//                                         //SelectPrice(click_elements); 
//                                         /*<--Subscription Widget bug*/
//                                     }
//                                 }
//                             }
//                         }, 1000)
//                     }

//                     if (dynamic_button_state == false && show_state) {
//                         dynamic_button_state = true;
//                         dynamicSubscribeButton();
//                     }
//                     // console.log("******************Found Recharge Subscription Widget!!!!");
//                 }
//             }
//         }
//     };


//     var observer = new MutationObserver(callback);
//     if (targetNode) {
//         observer.observe(targetNode, config);
//     } else {
//         console.error('targetNode not found. Make sure "predictive-search" exists in the DOM.');
//     }
// });

function addDetailsStyle(item){
    if(item.querySelector('rc-benefits')?.shadowRoot){
      var div = item.querySelector('rc-benefits').shadowRoot;
      if(item.querySelector('rc-selling-plans').shadowRoot){
        var select = item.querySelector('rc-selling-plans').shadowRoot;
        if(select.querySelector('select')){
          var select_options = select.querySelector('select')
      
          var style = document.createElement('style');
          var select_style = document.createElement('style');
      
          style.textContent = subscription_widget_benefits_content_style;
      
          select_style.textContent = subscription_widget_select_option_style;
      
          div.appendChild(style);
          select_options.appendChild(select_style);
        }
      }
    }
}

function createNewDetails(content, state){
    var rechargeWidget = document.querySelector('recharge-subscription-widget');
    var shadowRoot = rechargeWidget.shadowRoot;

    const clonedElements = content.cloneNode(true).children;
                            
    var new_content = document.createElement('div');
    new_content.classList.add('new-subscribe-content');

    if(state == 'one-time'){
        new_content.classList.add('show-element');
    }
    else if(state == 'subscribe'){
        new_content.classList.remove('show-element');
    }

    shadowRoot.querySelector('.rc-purchase-option__subscription').appendChild(new_content);

    setTimeout(() => {
        Array.from(clonedElements).forEach(element => {
            shadowRoot.querySelector('.rc-purchase-option__subscription .new-subscribe-content').appendChild(element.cloneNode(true));
            console.log('new subscription widget`s content has been created');
        });
    }, 100);
}

function dynamicSubscribeButton() {
    setTimeout(() => {
        if(document.querySelector('recharge-subscription-widget')){
            var rechargeWidget = document.querySelector('recharge-subscription-widget');
            
            var shadowRoot = rechargeWidget.shadowRoot;

            // Product varient option change event
            document.querySelector('variant-picker .opt-label--btn')?.addEventListener('click', function(){
                console.log("Product varient option change event............");
            });

            // Purchase option change event
            shadowRoot.querySelector('.rc-selection__root')?.addEventListener('change', function(){
                console.log("rechargeWidget changed............");
                var selects = shadowRoot.querySelectorAll('.rc-purchase-option');
                selects.forEach((item, index) => {
                    if (item.hasAttribute('rc-selected')) {
                        checkItem(item);
                        checkPrice(item);
                        click_check_box(item);
                    }

                    if (item.classList.contains('rc-selection__onetime')) {
                        changeClassname(shadowRoot.querySelector('.new-subscribe-content'), 'show-element', 'add')
                        // updateDynamicBadge(1);

                        var remove_element = shadowRoot.querySelector('.rc-purchase-option__subscription rc-radio-icon').shadowRoot;
                        if(remove_element.querySelectorAll('.new_chech_box').length > 0){
                        var remove_element_items = remove_element.querySelectorAll('.new_chech_box');

                        remove_element_items.forEach((item, index)=>{
                            item.remove();
                        })
                        
                        }
                    
                    }
                    else {
                        changeClassname(shadowRoot.querySelector('.new-subscribe-content'), 'show-element', 'remove');
                        // updateDynamicBadge(0.8);

                        var remove_element = shadowRoot.querySelector('.rc-selection__onetime rc-radio-icon').shadowRoot;
                        if(remove_element.querySelectorAll('.new_chech_box').length > 0){
                        var remove_element_items = remove_element.querySelectorAll('.new_chech_box');

                        remove_element_items.forEach((item, index)=>{
                            item.remove();
                        })
                        
                        }

                        setTimeout(()=>{
                        addDetailsStyle(item)
                        }, 100)
                    }
                });
            });

            // Manually fire change event at first time
            var element = shadowRoot.querySelector('.rc-selection__root');
            if ( element ){
                const event = new Event('change', {
                    bubbles: true,
                    cancelable: true,
                  });
                
                element.dispatchEvent(event);
            }
            
        }
        /* <-- Subscription Widget bug*/
    }, 100)
}

function checkItem(item) {
    if (item.classList.contains('rc-purchase-option__subscription')) {
        changeDynamicButton('Subscribe')
    }
    else if (item.classList.contains('rc-selection__onetime')) {
        changeDynamicButton('Add to cart');
    }
}

function changeClassname(element, name, state) {
    if (state == 'add') {
        element.classList.add(name);
    }
    else if (state == 'remove') {
        element.classList.remove(name)
    }
}

function close_interval(fu) {
    clearInterval(fu)
}

function SelectPrice(values) {
    values.forEach((item, index) => {
        item.addEventListener('click', function () {
            checkPrice(item)
        })
    })
}

function checkPrice(item){
    var prices = item.querySelectorAll('.rc-purchase-option__prices .rc-price');
    var original_price = document.querySelector('.product-info .product-info__block .price__default .price__was').textContent;//Bug: dynamic pricing not showing correctly 
    console.log("original price: " + original_price);
    if (prices.length == 1) {
        var price = prices[0].textContent.split('$')[1];
        var orig_price = original_price.split('$')[1];//Bug: dynamic pricing not showing correctly 

        console.log("check price: " + price);
        if (price != document.querySelector('.product-info .product-info__block .price__default .price__current').textContent) {
            document.querySelector('.product-info .product-info__block .price__default .price__current').textContent = `$ ${price}`;
        }

        //-->Bug: dynamic pricing not showing correctly 
        // --> Savings options in theme editor
        document.querySelectorAll('.saving-price').forEach(element => {
            if ( element.dataset.style == 'percent'){
                let comparePrice = parseFloat(element.dataset.compare); // Original price
                let currentPrice = parseFloat(element.dataset.price);  // Discounted price
                let originalPrice = parseFloat(element.dataset.original); // Original price for one-time purchase
            
                let savingPercent = ((comparePrice - currentPrice) / comparePrice) * 100; 
            
                if (item.hasAttribute('rc-selected') && item.classList.contains('rc-selection__onetime')) {
                    savingPercent = ((comparePrice - originalPrice) / comparePrice) * 100;
                }
            
                savingPercent = savingPercent.toFixed(0); // Round to 2 decimal places
            
                setTimeout(() => {
                    element.textContent = 'Save ' + savingPercent + '%';
                }, 50);
            
                console.log("Updated dynamic saving badge: " + savingPercent + "%");
            } else {
                let savingPrice = (element.dataset.compare - element.dataset.price) / 100;
                if (item.hasAttribute('rc-selected') && item.classList.contains('rc-selection__onetime') ) {
                    savingPrice = (element.dataset.compare - element.dataset.original) / 100;
                }
                    
                savingPrice = savingPrice.toFixed(2); // Ensures two decimal places  Bug: dynamic pricing not showing correctly
                setTimeout(()=>{
                    element.textContent = 'Save $' + savingPrice;
                }, 50);
                console.log("updated dynamic saving badge: " + savingPrice);
            }
            
        });
        //<--Bug: dynamic pricing not showing correctly 
    }
    else {
        prices.forEach((it, index) => {
            if (it.querySelector('.visually-hidden')) {
                var price = it.textContent.split('$')[1];
                var orig_price = original_price.split('$')[1];//Bug: dynamic pricing not showing correctly 
                console.log("check prices: " + price);
                if (price != document.querySelector('.product-info .product-info__block .price__default .price__current').textContent) {
                    document.querySelector('.product-info .product-info__block .price__default .price__current').textContent = `$ ${price}`;
                }
                //-->Bug: dynamic pricing not showing correctly 
                // --> Savings options in theme editor
                document.querySelectorAll('.saving-price').forEach(element => {
                    if ( element.dataset.style == 'percent'){
                        let comparePrice = parseFloat(element.dataset.compare); // Original price
                        let currentPrice = parseFloat(element.dataset.price);  // Discounted price
                        let originalPrice = parseFloat(element.dataset.original); // Original price for one-time purchase
                    
                        let savingPercent = ((comparePrice - currentPrice) / comparePrice) * 100; 
                    
                        if (item.hasAttribute('rc-selected') && item.classList.contains('rc-selection__onetime')) {
                            savingPercent = ((comparePrice - originalPrice) / comparePrice) * 100;
                        }
                    
                        savingPercent = savingPercent.toFixed(0); // Round to 2 decimal places
                    
                        setTimeout(() => {
                            element.textContent = 'Save ' + savingPercent + '%';
                        }, 50);
                    
                        console.log("Updated dynamic saving badge: " + savingPercent + "%");
                    } else {
                        let savingPrice = (element.dataset.compare - element.dataset.price) / 100;
                        if (item.hasAttribute('rc-selected') && item.classList.contains('rc-selection__onetime') ) {
                            savingPrice = (element.dataset.compare - element.dataset.original) / 100;
                        }
                            
                        savingPrice = savingPrice.toFixed(2); // Ensures two decimal places  Bug: dynamic pricing not showing correctly
                        setTimeout(()=>{
                            element.textContent = 'Save $' + savingPrice;
                        }, 50);
                        console.log("updated dynamic saving badge: " + savingPrice);
                    }
                    
                });
                //<--Bug: dynamic pricing not showing correctly 
            }
        })
    }
}


function add_svg_hide_style(item) {
    var se_shadow_root = item.shadowRoot;

    var style = document.createElement('style');

    style.textContent = subscription_widget_hidden_svg_style;

    se_shadow_root.appendChild(style);
}

function click_check_box(item) {
    setTimeout(() => {
        var div = item.querySelector('.rc-purchase-option__checked-indicator').shadowRoot;

        var style = document.createElement('style');

        style.textContent = subscription_widget_parchace_option_check_box_style;

        div.appendChild(style);

        var new_element = document.createElement('div');
        var content = document.createElement('div');
        new_element.appendChild(content);
        new_element.classList.add('new_chech_box');
        div.appendChild(new_element);
    }, 100)
}


document.addEventListener("DOMContentLoaded", function () {
    var element = document.querySelectorAll('.option-selector__btns .opt-label');

    element.forEach((item, index) => {
        item.addEventListener('click', function () {
            var rechargeWidget = document.querySelector('recharge-subscription-widget');
            var shadowRoot = rechargeWidget.shadowRoot;

            var ele = shadowRoot.querySelectorAll('.rc-purchase-option');
            ele.forEach((item, index) => {
                if (item.hasAttribute('rc-selected')) {
                    var prices = item.querySelectorAll('.rc-purchase-option__prices .rc-price');
                    if (prices.length == 1) {
                        var price = prices[0].textContent.split('$')[1];
                        if (price != document.querySelector('.product-info .product-info__block .price__default .price__current').textContent) {
                            document.querySelector('.product-info .product-info__block .price__default .price__current').textContent = `$ ${price}`;
                            setTimeout(() => {
                                item.click();
                            }, 10);
                        }
                    }
                    else {
                        prices.forEach((it, index) => {
                            if (it.querySelector('.visually-hidden')) {
                                var price = it.textContent.split('$')[1];
                                if (price != document.querySelector('.product-info .product-info__block .price__default .price__current').textContent) {
                                    document.querySelector('.product-info .product-info__block .price__default .price__current').textContent = `$ ${price}`;
                                    setTimeout(() => {
                                        item.click();
                                    }, 10);
                                }
                            }
                        })
                    }
                }
            })

            setTimeout(() => {
                var compare_at_price_value = document.querySelector('.product-info .product-info__block .price__default .price__was').textContent;

                if (compare_at_price_value) {
                    changeCompareAtPrice(compare_at_price_value);
                    console.log(compare_at_price_value);
                }
                else {
                    var price = shadowRoot.querySelector('.rc-selection__onetime .rc-price').textContent;
                    console.log(compare_at_price_value, price)
                    changeCompareAtPrice(price);
                }
            }, 100)
        })
    })
})

function updateDynamicBadge(discount) {
    // document.querySelectorAll('.saving-price').forEach(element => {
    //     var savingPrice = (element.dataset.compare - element.dataset.price * discount) / 100;
    //     element.textContent = 'Save $' + savingPrice;
    // });
}

function changeCompareAtPrice(price) {
    var price = price;

    var rechargeWidget = document.querySelector('recharge-subscription-widget');
    var shadowRoot = rechargeWidget.shadowRoot;

    shadowRoot.querySelector('.rc-purchase-option__subscription .new-stike-price').textContent = price;

    console.log('new subscription widget`s compare at price has been created')
}

function changeDynamicButton(text) {
    const add_to_cart_button = document.querySelectorAll('.product-info__add-button');

    add_to_cart_button.forEach((item, index) => {
        item.querySelector('button').textContent = `${text}`;
    })

    /*-->Adding dynamic option name above subscription widget on pdp*/
    console.log("change purchase heading: " + text);
    const purchase_heading = document.querySelectorAll('.product-purchase-heading');

    purchase_heading.forEach((item, index) => {
        if ( text == "Subscribe"){
            item.textContent  = "Purchase: Subscription"
        }
        else {
            item.textContent  = "Purchase: One Time"
        }
    })
    /*<--Adding dynamic option name above subscription widget on pdp*/
}




